/**
 * Extend vue from directives ...
 * @param vue
 * @param callback
 * @see https://stackoverflow.com/questions/1959040/is-it-possible-to-send-a-variable-number-of-arguments-to-a-javascript-function
 */
export default (vue, callback) => {
    vue.set = (path,value) => {
        let a = path.split('.');
        let o = vue.ctx.scope;
        while (a.length - 1) {
            let n = a.shift();
            if (!(n in o)) o[n] = {};
            o = o[n]
        }
        o[a[0]] = value;
    };

    vue.intersect = (callback) => {
        let intersect = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    intersect.unobserve(entry.target);
                    callback();
                }
            });
        });
        intersect.observe(vue.el);
    };

    let called = callback(vue);

    if ( called && typeof called.init !== "undefined") {
        called.init();
    }
};